import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/layout';
import NavHeader from '/src/components/nav-header';
import PageFooter from '/src/components/v2/page-footer';
import Seo from '../components/seo';

const DataSubjectAccessRequests = () => {
	const { t } = useTranslation(null, { keyPrefix: 'data-subject-access-requests' });

	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
		script.async = true;
		document.body.appendChild(script);

		script.onload = () => {
			if (window.jotformEmbedHandler) {
				window.jotformEmbedHandler('iframe[id=\'JotFormIFrame-250425315917051\']', 'https://form.jotform.com/');
			}
		};
	}, []);

	return (
		<Layout>
			<div id="data-subject-access-requests-page">
				<Seo title="Data Subject Access Requests" />
				<NavHeader dark />
				<section id="data-subject-access-requests">
					<div>
						<header>
							<h1>{t('data-subject-access-requests')}</h1>
							<p>{t('updated-april-twenty-twenty-five')}</p>
						</header>

						<article>
							<p>{t('this-policy-outlines')}</p>
						</article>

						<article>
							<h4>{t('scope')}</h4>
							<p>{t('this-policy-applies')}</p>
						</article>

						<article>
							<h4>{t('submitting-a-request')}</h4>

							<p>{t('requests-must-be')} <a href="https://form.jotform.com/250935235662156" target="_blank" rel="noreferrer">{t('dsar-request-form')}</a>{t('or-by-contacting')} </p>
							<ul>
								<li>{t('full-name')}</li>
								<li>{t('description-of-the-data')}</li>
								<li>{t('reason-for-request')}</li>
								<li>{t('government-issued-id')}</li>
							</ul>
						</article>

						<article>
							<h4>{t('verification-of-identity')}</h4>

							<p>{t('dti-may-request')}</p>

						</article>

						<article>
							<h4>{t('response-time')}</h4>

							<p>{t('we-aim-to-respond')}</p>

						</article>

						<article>
							<h4>{t('limitations-and-exemptions')}</h4>

							<p>{t('dti-reserves-the-right')}</p>
							<ul>
								<li>{t('disclosing-the-data')}</li>
								<li>{t('the-request-is')}</li>
								<li>{t('the-data-is-subject')}</li>
							</ul>

						</article>

						<article>
							<h4>{t('third-party-data')}</h4>

							<p>{t('video-or-audio')}</p>
							<ul>
								<li>{t('dti-may-redact')}</li>
								<li>{t('dti-may-deny')}</li>
							</ul>

						</article>

						<article>
							<h4>{t('requests-from-authorities')}</h4>

							<p>{t('law-enforcement')}</p>

						</article>

						<article>
							<h4>{t('guidelines-for-evaluating')}</h4>

							<p>{t('dti-reviews-each')}</p>
							<p>{t('dti-will-deny')}</p>
							<ul>
								<li>{t('the-footage-contains')}</li>
								<li>{t('the-footage-involves')}</li>
								<li>{t('the-requester-is-not')}</li>
							</ul>
							<p>{t('dti-may-grant')}</p>
							<ul>
								<li>
									{t('there-is-clear')}
									<ul style={{ marginTop: '0.5em', marginBottom: '0.5em', paddingLeft: '1.5em' }}>
										<li>{t('law-enforcement-investigation')}</li>
										<li>{t('legal-proceedings')}</li>
										<li>{t('insurance-claims')}</li>
									</ul>
								</li>
								<li>{t('redaction-of-third-party')}</li>
							</ul>

						</article>

						<article>
							{/* JotForm Embed */}
							<iframe
								id="JotFormIFrame-250425315917051"
								title="Data Subject Access Request"
								allow="geolocation; microphone; camera; fullscreen"
								src="https://form.jotform.com/250935235662156"
								frameBorder="0"
								style={{ minWidth: '100%', maxWidth: '100%', height: '539px', border: 'none' }}
								scrolling="no"></iframe>

						</article>
					</div>
				</section>
				<PageFooter dark />
			</div>
		</Layout>
	);
};

export default DataSubjectAccessRequests;
